/* Saffwell PDP v2 — gallery, tier ladder, accordion, hotspots, timeline */
(function () {
  "use strict";
  /* Appstle's app embed wraps BOTH window.fetch and XMLHttpRequest and rewrites
     /cart/add payloads to match its own (hidden) widget state — which silently
     strips the selling plan this buybox picked. A fresh same-origin iframe has
     an untouched fetch, so the request goes out exactly as built. */
  var _cleanFetch = null;
  function cleanFetch() {
    if (_cleanFetch) return _cleanFetch;
    try {
      var f = document.createElement("iframe");
      f.setAttribute("aria-hidden", "true");
      f.style.cssText = "position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none;";
      document.body.appendChild(f);
      var w = f.contentWindow;
      if (w && typeof w.fetch === "function" && w.fetch.toString().indexOf("[native code]") > -1) {
        _cleanFetch = w.fetch.bind(w);
        return _cleanFetch;
      }
    } catch (e) { /* fall through */ }
    _cleanFetch = window.fetch.bind(window);
    return _cleanFetch;
  }

  var money = function (cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || "${{amount}}").replace(/\{\{\s*amount\s*\}\}/, v);
  };

  /* ---------- gallery: peek rail, swipe + pointer drag ---------- */
  function gallery(root) {
    var rail = root.querySelector("[data-sw-rail]");
    var slides = root.querySelectorAll("[data-sw-slide]");
    if (!rail || !slides.length) return;

    function paint() {
      var w = slides[0].getBoundingClientRect().width + 10;
      var i = Math.round(rail.scrollLeft / w);
      rail.dataset.swIndex = i;
    }
    var ticking = false;
    rail.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });
    window.addEventListener("resize", paint);
    paint();

    // pointer drag for desktop mice; touch already scrolls natively
    var down = false, startX = 0, startScroll = 0, moved = 0;
    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return;
      down = true; moved = 0;
      startX = e.clientX; startScroll = rail.scrollLeft;
      rail.classList.add("is-dragging");
    });
    rail.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      rail.scrollLeft = startScroll - dx;
      if (moved > 4) e.preventDefault();
    });
    function release() {
      if (!down) return;
      down = false;
      rail.classList.remove("is-dragging");
      // snap to nearest slide once snapping is re-enabled
      var w = slides[0].getBoundingClientRect().width + 10;
      rail.scrollTo({ left: Math.round(rail.scrollLeft / w) * w, behavior: "smooth" });
    }
    rail.addEventListener("pointerup", release);
    rail.addEventListener("pointercancel", release);
    rail.addEventListener("pointerleave", release);
  }

  /* ---------- supplement facts modal ---------- */
  function factsModal(root) {
    var openBtn = root.querySelector("[data-sw-facts-open]");
    var modal = root.querySelector("[data-sw-modal]");
    if (!openBtn || !modal) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("sw-modal-open");
      var close = modal.querySelector("[data-sw-modal-close]");
      if (close) close.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove("sw-modal-open");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtn.addEventListener("click", open);
    modal.querySelectorAll("[data-sw-modal-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (!modal.hidden && (e.key === "Escape" || e.keyCode === 27)) close();
    });
  }

  /* ---------- tier ladder ---------- */
  function tiers(root) {
    var inputs = root.querySelectorAll("[data-sw-tier]");
    var btnWas = root.querySelector("[data-sw-atc-was]");
    var btnNow = root.querySelector("[data-sw-atc-now]");
    var fmt = root.dataset.swMoneyFormat;
    if (!inputs.length) return;

    function apply(input) {
      var label = input.closest(".sw-tier");
      root.querySelectorAll(".sw-tier").forEach(function (l) { l.classList.remove("is-active"); });
      if (label) label.classList.add("is-active");
      var d = input.dataset;
      root.swSelection = {
        id: d.variantId || "",
        selling_plan: d.sellingPlan || "",
        quantity: parseInt(d.quantity || "1", 10) || 1
      };
      if (btnNow) btnNow.textContent = d.priceLabel || "";
      var dayEl = root.querySelector("[data-sw-atc-day]");
      if (dayEl) {
        dayEl.textContent = d.perDay ? "· " + d.perDay : "";
        dayEl.style.display = d.perDay ? "" : "none";
      }
      if (btnWas) {
        btnWas.textContent = d.compareLabel || "";
        btnWas.style.display = d.compareLabel ? "" : "none";
      }
    }
    inputs.forEach(function (input) {
      input.addEventListener("change", function () { if (input.checked) apply(input); });
    });
    var checked = root.querySelector("[data-sw-tier]:checked") || inputs[0];
    checked.checked = true;
    apply(checked);
  }

  /* ---------- add to cart ---------- */
  function atc(root) {
    var host = root.querySelector("[data-sw-form]");
    if (!host) return;
    var btn = host.querySelector("[data-sw-atc]");
    var err = root.querySelector("[data-sw-err]");
    if (!btn) return;

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.getAttribute("aria-disabled") === "true") return;
      var sel = root.swSelection;
      if (!sel || !sel.id) return;

      btn.setAttribute("aria-disabled", "true");
      if (err) err.classList.remove("is-on");

      var item = { id: Number(sel.id), quantity: sel.quantity || 1 };
      if (sel.selling_plan) item.selling_plan = Number(sel.selling_plan);

      cleanFetch()((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          btn.removeAttribute("aria-disabled");
          if (json.status && json.status !== 200) {
            if (err) {
              err.textContent = json.description || json.message || "Could not add to cart.";
              err.classList.add("is-on");
            }
            return;
          }
          document.dispatchEvent(new CustomEvent("sw:cart-added", { bubbles: true }));
          var drawer = document.querySelector("cart-drawer");
          var trigger = document.querySelector(".wt-cart__trigger");
          if (drawer && drawer.dataset.cartType === "drawer" && trigger) {
            document.dispatchEvent(new CustomEvent("cart-drawer:refresh", { bubbles: true }));
            setTimeout(function () {
              if (!drawer.hasAttribute("open")) trigger.click();
            }, 260);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || "/cart";
          }
        })
        .catch(function () {
          btn.removeAttribute("aria-disabled");
          window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        });
    });
  }

  /* ---------- accordion ---------- */
  function accordion(root) {
    var items = root.querySelectorAll("[data-sw-acc-item]");
    items.forEach(function (item) {
      var btn = item.querySelector("[data-sw-acc-btn]");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        items.forEach(function (o) { o.classList.remove("is-open"); });
        if (!open) {
          item.classList.add("is-open");
          var img = item.dataset.swAccImage;
          if (img) {
            // two copies exist (desktop column + stacked inline); swap both
            root.querySelectorAll("[data-sw-acc-media]").forEach(function (t) {
              t.setAttribute("src", img);
            });
          }
        }
      });
    });
  }

  /* ---------- hotspots ---------- */
  function hotspots(root) {
    var dots = root.querySelectorAll("[data-sw-dot]");
    dots.forEach(function (dot) {
      var toggle = function () {
        var on = dot.classList.contains("is-on");
        dots.forEach(function (d) { d.classList.remove("is-on"); });
        if (!on) dot.classList.add("is-on");
      };
      dot.addEventListener("click", toggle);
      dot.addEventListener("mouseenter", function () {
        dots.forEach(function (d) { d.classList.remove("is-on"); });
        dot.classList.add("is-on");
      });
    });
  }

  /* ---------- card carousel arrows ---------- */
  function cards(root) {
    var rail = root.querySelector("[data-sw-cards]");
    if (!rail) return;
    var step = function () {
      var c = rail.querySelector(".sw-card");
      return c ? c.getBoundingClientRect().width + 14 : 260;
    };
    var prev = root.querySelector("[data-sw-cards-prev]");
    var next = root.querySelector("[data-sw-cards-next]");
    if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
  }

  /* ---------- timeline: sticky scrub on desktop, rail reveal on mobile ---------- */
  function timeline(root) {
    if (root.swTlBooted) return;
    root.swTlBooted = true;

    var scroller = root.querySelector("[data-sw-tl-scroll]");
    var cols = root.querySelectorAll("[data-sw-tl-col]");
    var dots = root.querySelectorAll("[data-sw-tl-dot]");
    var spine = root.querySelector("[data-sw-tl-spine]");
    if (!cols.length) return;

    var n = cols.length;
    var mq = window.matchMedia("(max-width: 759px)");
    // Liquid sets the scrub track height inline; remember it so the desktop
    // path can restore it instead of wiping it and collapsing the track
    var baseHeight = scroller ? scroller.style.height : "";

    /* ---- mobile: scrub each step against the reading line ---- */
    var rafPending = false, mobileScroll = null;
    function mobileOn() {
      if (scroller) scroller.style.height = "auto";

      function frame() {
        var vh = window.innerHeight;
        var line = vh * 0.78;      // where a step counts as "arrived"
        var span = vh * 0.34;      // how much scroll the reveal takes
        var sum = 0;
        for (var i = 0; i < n; i++) {
          var r = cols[i].getBoundingClientRect();
          var p = (line - r.top) / span;
          p = p < 0 ? 0 : (p > 1 ? 1 : p);
          cols[i].style.setProperty("--p", p.toFixed(3));
          cols[i].classList.toggle("is-on", p > 0.5);
          sum += p;
        }
        if (spine) spine.style.height = ((sum / n) * 100).toFixed(2) + "%";
      }

      mobileScroll = function () {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () { frame(); rafPending = false; });
      };
      window.addEventListener("scroll", mobileScroll, { passive: true });
      window.addEventListener("resize", mobileScroll);
      frame();
    }

    /* ---- desktop: scrub the sticky stage ---- */
    var scrollHandler = null;
    function desktopOn() {
      if (!scroller) return;
      scroller.style.height = baseHeight;
      function paint() {
        var r = scroller.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        if (total <= 0) {
          cols.forEach(function (c) { c.classList.add("is-on"); });
          dots.forEach(function (d) { d.classList.add("is-on"); });
          return;
        }
        var p = Math.min(1, Math.max(0, -r.top / total));
        var active = Math.min(n - 1, Math.floor(p * n + 0.0001));
        cols.forEach(function (c, i) { c.classList.toggle("is-on", i <= active); });
        dots.forEach(function (d, i) { d.classList.toggle("is-on", i <= active); });
      }
      var ticking = false;
      scrollHandler = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { paint(); ticking = false; });
      };
      window.addEventListener("scroll", scrollHandler, { passive: true });
      window.addEventListener("resize", paint);
      paint();
    }

    function teardown() {
      if (mobileScroll) {
        window.removeEventListener("scroll", mobileScroll);
        window.removeEventListener("resize", mobileScroll);
        mobileScroll = null;
      }
      if (scrollHandler) { window.removeEventListener("scroll", scrollHandler); scrollHandler = null; }
      cols.forEach(function (c) { c.style.removeProperty("--p"); });
      cols.forEach(function (c) { c.classList.remove("is-on"); });
      dots.forEach(function (d) { d.classList.remove("is-on"); });
      if (spine) spine.style.height = "";
    }
    function apply() {
      teardown();
      if (mq.matches) mobileOn(); else desktopOn();
    }
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  /* ---------- ingredient story popup ---------- */
  function ingredientStory(root) {
    if (root.swStoryBooted) return;
    root.swStoryBooted = true;

    var openBtn = root.querySelector("[data-sw-ing-open]");
    var modal = root.querySelector("[data-sw-ing-modal]");
    if (!openBtn || !modal) return;

    var track = modal.querySelector("[data-sw-story-track]");
    var slides = modal.querySelectorAll("[data-sw-story-slide]");
    var bars = modal.querySelectorAll(".sw-story__bar");
    var cue = modal.querySelector("[data-sw-story-cue]");
    var priceEl = modal.querySelector("[data-sw-story-price]");
    var atc = modal.querySelector("[data-sw-story-atc]");
    var lastFocus = null;

    function step() {
      return slides.length ? slides[0].getBoundingClientRect().height : 1;
    }
    function paint() {
      var i = Math.round(track.scrollTop / step());
      bars.forEach(function (b, k) {
        b.classList.toggle("is-done", k < i);
        b.classList.toggle("is-on", k === i);
      });
      if (cue) cue.classList.toggle("is-off", i > 0);
    }
    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });

    function go(dir) {
      var i = Math.round(track.scrollTop / step()) + dir;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ top: i * step(), behavior: "smooth" });
    }
    var prev = modal.querySelector("[data-sw-story-prev]");
    var next = modal.querySelector("[data-sw-story-next]");
    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });

    // mirror the buybox's live price onto the popup button
    function syncPrice() {
      if (!priceEl) return;
      var now = document.querySelector("[data-sw-atc-now]");
      priceEl.textContent = now ? now.textContent : "";
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("sw-modal-open");
      track.scrollTop = 0;
      syncPrice();
      paint();
      var c = modal.querySelector("[data-sw-ing-close]");
      if (c && c.focus) c.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove("sw-modal-open");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtn.addEventListener("click", open);
    modal.querySelectorAll("[data-sw-ing-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (modal.hidden) return;
      if (e.key === "Escape" || e.keyCode === 27) close();
      if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); go(1); }
      if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); go(-1); }
    });

    // the buybox owns the cart logic (tier, selling plan, clean fetch, drawer):
    // proxy the click rather than duplicating any of it
    if (atc) {
      atc.addEventListener("click", function () {
        var real = document.querySelector("[data-sw-atc]");
        close();
        if (real) { real.click(); return; }
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      });
    }
  }

  /* ---------- sticky pill bar ---------- */
  function stickyBar(bar) {
    if (bar.swBooted) return;
    bar.swBooted = true;

    var after = parseInt(bar.dataset.swShowAfter || "420", 10);
    var countEl = bar.querySelector("[data-sw-cart-count]");
    var cartBtn = bar.querySelector("[data-sw-sticky-cart]");
    var menuBtn = bar.querySelector("[data-sw-sticky-menu]");

    function paint() {
      var on = window.scrollY > after;
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
      // lift the storewide header out while ours is in, so only one bar shows
      document.body.classList.toggle("sw-sticky-on", on);
    }
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });
    paint();

    var last = null;
    function setCount(n) {
      if (!countEl) return;
      countEl.textContent = n;
      if (last !== null && n !== last && cartBtn) {
        cartBtn.classList.remove("is-bumped");
        void cartBtn.offsetWidth;
        cartBtn.classList.add("is-bumped");
      }
      last = n;
    }
    function refresh() {
      cleanFetch()("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }
    refresh();
    document.addEventListener("cart-drawer:refresh", function () { setTimeout(refresh, 400); });
    document.addEventListener("sw:cart-added", function () { setTimeout(refresh, 300); });

    if (menuBtn) {
      menuBtn.addEventListener("click", function () {
        var t = document.querySelector(".wt-header__menu-trigger");
        if (t) t.click();
      });
    }
    if (cartBtn) {
      cartBtn.addEventListener("click", function () {
        var t = document.querySelector(".wt-cart__trigger");
        if (t) { t.click(); return; }
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      });
    }
  }

  /* ---------- sticky bottom add-to-cart ---------- */
  function stickyAtc(bar) {
    if (bar.swBooted) return;
    bar.swBooted = true;

    var realAtc = document.querySelector("[data-sw-atc]");
    if (!realAtc) return;

    var nowEl = bar.querySelector("[data-sw-satc-now]");
    var wasEl = bar.querySelector("[data-sw-satc-was]");
    var tierEl = bar.querySelector("[data-sw-satc-tier]");
    var addBtn = bar.querySelector("[data-sw-satc-add]");
    var jumpBtn = bar.querySelector("[data-sw-satc-scroll]");

    // mirror whatever the buybox currently has selected
    function sync() {
      var now = document.querySelector("[data-sw-atc-now]");
      var was = document.querySelector("[data-sw-atc-was]");
      if (nowEl) nowEl.textContent = now ? now.textContent : "";
      if (wasEl) {
        wasEl.textContent = was ? was.textContent : "";
        wasEl.style.display = was && was.textContent ? "" : "none";
      }
      if (tierEl) {
        var active = document.querySelector(".sw-tier.is-active .sw-tier__name");
        tierEl.textContent = active ? active.textContent.trim() : "";
      }
    }
    sync();
    document.querySelectorAll("[data-sw-tier]").forEach(function (i) {
      i.addEventListener("change", function () { setTimeout(sync, 30); });
    });

    // show it only once the real button has scrolled out of view
    function show(on) {
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
    }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = e.boundingClientRect.top < 0;
          show(!e.isIntersecting && past);
        });
      }, { rootMargin: "0px 0px -10% 0px", threshold: 0 });
      io.observe(realAtc);
    } else {
      var ticking = false;
      window.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var r = realAtc.getBoundingClientRect();
          show(r.bottom < 0);
          ticking = false;
        });
      }, { passive: true });
    }

    if (addBtn) addBtn.addEventListener("click", function () { realAtc.click(); });
    if (jumpBtn) {
      jumpBtn.addEventListener("click", function () {
        var box = document.querySelector("[data-sw-buybox]") || realAtc;
        box.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }

  /* ---------- review card that types itself in ---------- */
  function typer(card) {
    if (card.swTyped) return;
    card.swTyped = true;

    var target = card.querySelector("[data-sw-type]");
    if (!target) return;

    var text = target.textContent;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) { card.classList.add("is-typed"); return; }

    // one span per character, so the reveal can walk the line like a cursor
    var frag = document.createDocumentFragment();
    var spans = [];
    for (var i = 0; i < text.length; i++) {
      var ch = document.createElement("span");
      ch.className = "sw-ch";
      ch.textContent = text[i];
      if (text[i] === " ") ch.style.whiteSpace = "pre";
      frag.appendChild(ch);
      spans.push(ch);
    }
    target.textContent = "";
    target.appendChild(frag);

    var caret = card.querySelector(".sw-hrev__caret");
    function run() {
      card.classList.add("is-typing");
      var i = 0;
      var perChar = Math.max(7, Math.min(18, 2600 / spans.length));
      var last = 0;
      function step(ts) {
        if (!last) last = ts;
        var due = Math.floor((ts - last) / perChar);
        while (i <= due && i < spans.length) {
          spans[i].style.opacity = "1";
          spans[i].style.filter = "none";
          // keep the caret travelling with the last lit character
          if (caret && spans[i].parentNode) {
            var r = spans[i];
            caret.style.transform = "none";
          }
          i++;
        }
        if (i < spans.length) {
          requestAnimationFrame(step);
        } else {
          card.classList.remove("is-typing");
          card.classList.add("is-typed");
        }
      }
      requestAnimationFrame(step);
    }

    if (!("IntersectionObserver" in window)) { run(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        run();
      });
    }, { rootMargin: "0px 0px -18% 0px", threshold: 0.25 });
    io.observe(card);
  }

  /* ---------- preview avatars on the Yotpo list ----------
     Yotpo renders its list client-side and ships a grey silhouette when a
     reviewer has no photo. This paints the supplied portraits onto those
     placeholders so the layout can be judged with faces in place. */
  function reviewAvatars(root) {
    if (root.swAvaBooted) return;
    root.swAvaBooted = true;

    var files = (root.dataset.swAvatars || "").split("|").filter(Boolean);
    if (!files.length) return;

    function paint() {
      var holders = root.querySelectorAll(
        '[class*="avatar" i]:not([data-sw-ava]),[class*="initials" i]:not([data-sw-ava])'
      );
      var n = 0;
      holders.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width < 18 || r.width > 90) return;   // avatar-sized only
        el.setAttribute("data-sw-ava", "1");
        el.style.backgroundImage = "url(" + files[n % files.length] + ")";
        el.style.backgroundSize = "cover";
        el.style.backgroundPosition = "center";
        el.style.borderRadius = "50%";
        el.style.color = "transparent";
        n++;
      });
      return n;
    }
    paint();
    if (!("MutationObserver" in window)) return;
    var mo = new MutationObserver(function () { paint(); });
    mo.observe(root, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  /* ---------- review list: reveal the rest ---------- */
  function reviewList(root) {
    if (root.swRvwBooted) return;
    root.swRvwBooted = true;
    var btn = root.querySelector("[data-sw-reviews-more]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      root.querySelectorAll("[data-sw-review].is-hidden").forEach(function (el) {
        el.classList.remove("is-hidden");
      });
      btn.remove();
    });
  }

  function boot(scope) {
    var d = scope || document;
    // each step is isolated: one section throwing must not stop the rest,
    // and the sticky bar goes first because it owns the header handoff
    function run(sel, fn) {
      try {
        d.querySelectorAll(sel).forEach(function (el) {
          try { fn(el); } catch (e) { if (window.console) console.warn("sw-pdp:", sel, e); }
        });
      } catch (e) { if (window.console) console.warn("sw-pdp:", sel, e); }
    }
    run("[data-sw-stickybar]", stickyBar);
    run("[data-sw-stickyatc]", stickyAtc);
    run("[data-sw-buybox]", function (r) {
      if (r.swBooted) return;   // 4 script tags on the page; bind once
      r.swBooted = true;
      [gallery, tiers, atc, factsModal].forEach(function (fn) {
        try { fn(r); } catch (e) { if (window.console) console.warn("sw-pdp buybox:", fn.name, e); }
      });
    });
    run("[data-sw-accordion]", accordion);
    run("[data-sw-typer]", typer);
    run("[data-sw-avatars]", reviewAvatars);
    run("[data-sw-reviews]", reviewList);
    run("[data-sw-hotspots]", function (r) { hotspots(r); cards(r); });
    run("[data-sw-ing-modal]", function (m) {
      var host = m.closest(".shopify-section") || m.parentElement;
      if (host) ingredientStory(host);
    });
    run("[data-sw-timeline]", timeline);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  window.SWPDP = { boot: boot, money: money };
})();
